import request from '../tools/request'
import { HTTP } from './http'

const { GET } = request

// 慧穗云访问令牌响应类型
export interface HuiShuiYunTokenResponse {
  code: string // 业务码，200表示成功，非200表示异常
  message: string // 业务信息
  data: string // 业务数据（访问令牌）
  serialNo: string // 返回流水号
}

// 获取慧穗云访问令牌参数
export interface GetHuiShuiYunTokenParams {
  forceUpdate?: boolean // 是否强制更新令牌（可选参数，默认false）
}

/**
 * 获取慧穗云访问令牌
 * 获取慧穗云系统的访问令牌，用于后续API调用的身份验证
 * @param params 请求参数
 * @returns Promise<HuiShuiYunTokenResponse>
 */
export const GET_HUISHUIYUN_TOKEN_OLD = (params?: GetHuiShuiYunTokenParams) =>
  GET<HuiShuiYunTokenResponse>(`${HTTP}/huishuiyun/getToken`, params || {})

/**
 * 结果数据
 *
 * HuiShuiYunSsoResponse
 */
export interface HuiShuiYunSsoResponse {
  /**
   * 业务码，200表示成功，非200表示异常
   */
  code?: string
  /**
   * 业务数据
   */
  data?: string
  /**
   * 业务信息
   */
  message?: string
  /**
   * 返回流水号
   */
  serialNo?: string
  [property: string]: any
}

export interface GetHuiShuiYunSsoParams {
  /**
   * 税号信息（ISV token通用接口时为必填） 税号信息（ISV token通用接口时为必填）
   */
  taxToken: string
  [property: string]: any
}

export const GET_HUISHUIYUN_TOKEN = (params?: GetHuiShuiYunSsoParams) =>
  GET<HuiShuiYunSsoResponse>(`${HTTP}/huishuiyun/ssoToken`, params || {})
import request from '../tools/request'
import { HTTP } from './http'

const { GET } = request

// 慧穗云访问令牌响应类型
export interface HuiShuiYunTokenResponse {
  code: string // 业务码，200表示成功，非200表示异常
  message: string // 业务信息
  data: string // 业务数据（访问令牌）
  serialNo: string // 返回流水号
}

// 获取慧穗云访问令牌参数
export interface GetHuiShuiYunTokenParams {
  forceUpdate?: boolean // 是否强制更新令牌（可选参数，默认false）
}

/**
 * 获取慧穗云访问令牌
 * 获取慧穗云系统的访问令牌，用于后续API调用的身份验证
 * @param params 请求参数
 * @returns Promise<HuiShuiYunTokenResponse>
 */
export const GET_HUISHUIYUN_TOKEN_OLD = (params?: GetHuiShuiYunTokenParams) =>
  GET<HuiShuiYunTokenResponse>(`${HTTP}/huishuiyun/getToken`, params || {})

/**
 * 结果数据
 *
 * HuiShuiYunSsoResponse
 */
export interface HuiShuiYunSsoResponse {
  /**
   * 业务码，200表示成功，非200表示异常
   */
  code?: string
  /**
   * 业务数据
   */
  data?: string
  /**
   * 业务信息
   */
  message?: string
  /**
   * 返回流水号
   */
  serialNo?: string
  [property: string]: any
}

export interface GetHuiShuiYunSsoParams {
  /**
   * 税号信息（ISV token通用接口时为必填） 税号信息（ISV token通用接口时为必填）
   */
  taxToken: string
  [property: string]: any
}

export const GET_HUISHUIYUN_TOKEN = (params?: GetHuiShuiYunSsoParams) =>
  GET<HuiShuiYunSsoResponse>(`${HTTP}/huishuiyun/ssoToken`, params || {})
